module.exports = __webpack_public_path__ + "img/phonecall_icon_white.83b4ab58.svg";